<template>
  <div class="pony-image-holder">
    <transition-group tag="div" name="fade">
      <figure v-show="image.show" v-for="image in images" :key="image.id" class="pony-image">
        <img :src="`/pony-images/${image.image_path}`" alt="">
        <!-- <button v-if="authenticated && user.role_id === 1" class="button-remove-image" @click="removeImage(image.id)">&times;</button> -->
      </figure>
    </transition-group>
    <div class="pony-image-nav">
      <button class="pager" @click="prevImage"><i class="fa fa-caret-left"></i></button>
      <button class="pager" @click="nextImage"><i class="fa fa-caret-right"></i></button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'PonyImageSlideshow',
  props: {
    authenticated: {
      type: Boolean
    },
    user: {
      type: Object
    },
    images: {
      type: Array,
      required: true
    }
  },
  methods: {
    nextImage() {
      const currentIndex = this.images.findIndex(o => o.show === true);
      const numImages = this.images.length;
      let next;

      // if its the last one
      if (currentIndex === numImages - 1) {
        next = 0;
      } else {
        next = currentIndex + 1;
      }

      this.$emit('nextImage', {
        image: next
      });
    },
    prevImage() {
      const currentIndex = this.images.findIndex(o => o.show === true);
      let prev;

      // if its the first one
      if (currentIndex === 0) {
        prev = this.images.length - 1;
      } else {
        prev = currentIndex - 1;
      }

      this.$emit('prevImage', {
        image: prev
      });
    },
    removeImage(id) {
      if (!window.confirm('Do you really want to delete this image?')) {
        return false;
      }

      axios
        .delete(`/image/${id}`)
        .then(() => {
          this.$emit('removedImage', {
            id
          });
        })
        .catch(e => {
          if (e && e.response) {
            this.errors.push(e.response.data);
            this.showErrorMessage('Could not remove image');
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.button-remove-image {
  color: red;
  font-size: 36px;
  display: block;
  background-color: #fff;
  padding: 0 8px;
  line-height: 1;
  position: absolute;
  top: 5px;
  right: 5px;
}

.pager {
  background-color: transparent;
  border-radius: 3px;
  cursor: pointer;
  width: 50px;
  height: 50px;

  i {
    color: #fff;
    font-size: 36px;
  }
}

.pony-image-holder {
  width: 460px;
  height: 350px;
  margin: 20px auto;
  position: relative;
  overflow: hidden;
}

.pony-image-nav {
  display: flex;
  justify-content: space-between;
  position: absolute;
  width: 100%;
  height: 50px;
  transform: translate(0, -50%);
  top: 50%;
  left: 0;
}

.pony-image {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  max-width: 460px;
  height: auto;
  // display: none;

  img {
    display: block;
    max-width: 100%;
    height: auto;
  }
}
</style>
